import { createApi } from '@reduxjs/toolkit/query/react';
import deserialize from 'helpers/getroPropertyMapper';
import { networkBaseQueryV2 } from './queries';
import { contactsApi } from './contacts';

export const findemApiV2 = createApi({
  reducerPath: 'findemApiV2',
  baseQuery: networkBaseQueryV2,
  tagTypes: ['sourcingCampaigns'],
  endpoints: (builder) => ({
    getFindemAuth: builder.query({
      query: (collectionId) => ({
        url: `/findem/auth`,
        networkId: collectionId,
      }),
    }),

    createSourcingCampaign: builder.mutation({
      query: ({ sharedListId, calibrate }) => ({
        url: `/sourcing_campaigns`,
        method: 'post',
        params: {
          ...(sharedListId ? { sharedListId } : {}),
          ...(calibrate !== undefined ? { calibrate } : {}),
        },
      }),
      invalidatesTags: ['sourcingCampaigns'],
      async onQueryStarted({ sharedListId }, { dispatch, queryFulfilled }) {
        try {
          const { data: campaignResponse } = await queryFulfilled;

          if (campaignResponse && sharedListId) {
            dispatch(
              contactsApi.util.updateQueryData('getSharedList', { listId: sharedListId?.toString() }, (draft) => {
                if (draft?.sharedList) {
                  Object.assign(draft.sharedList, {
                    sourcingCampaign: {
                      ...campaignResponse,
                      campaignId: campaignResponse.id,
                      sharedListId,
                    },
                  });
                }
              }),
            );
          }
        } catch {
          // ignore error
        }
      },
      transformResponse: (response) => deserialize(response),
    }),
    updateSourcingCampaign: builder.mutation({
      query: ({ id, icpId, outreachChatSessionId, calibrateChatSessionId, sessionId, status, agentId }) => ({
        url: `/sourcing_campaigns/${id}`,
        method: 'put',
        params: {
          ...(icpId ? { icpId } : {}),
          ...(outreachChatSessionId ? { outreachChatSessionId } : {}),
          ...(calibrateChatSessionId ? { calibrateChatSessionId } : {}),
          ...(sessionId ? { sessionId } : {}),
          ...(status ? { status } : {}),
          ...(agentId ? { agentId } : {}),
        },
      }),
      invalidatesTags: ['sourcingCampaigns'],
    }),
    getFindemSsoUrl: builder.query({
      query: ({ collectionId, redirectUri }) => ({
        url: `/findem/sso_url`,
        networkId: collectionId,
        params: { redirectUri },
      }),
    }),
  }),
});

export const {
  useGetFindemAuthQuery,
  useLazyGetFindemAuthQuery,
  useGetFindemPublicAuthQuery,
  useLazyGetFindemPublicAuthQuery,
  useCreateSourcingCampaignMutation,
  useUpdateSourcingCampaignMutation,
  useLazyGetFindemSsoUrlQuery,
} = findemApiV2;
